import * as React from 'react'
import {connect} from 'react-redux'

export const Status = ({}) => {
  return(
    <div>Ok</div>
  )}

export const StatusConnected = connect(({}: any) => ({}),{})(Status)
